export default __webpack_public_path__ + "static/O0291-2f4c982894c026fb63a5be86be8a098e.png";